class ProductDescriptionCollapsible {
  constructor(container) {
    this.container = container;
    this.description = container.querySelector('[data-description-collapsible]');
    this.toggle = container.querySelector('[data-description-toggle]');
    
    if (!this.description || !this.toggle) return;
    
    this.toggleText = this.toggle.querySelector('.product__description-toggle-text');
    this.isExpanded = false;
    
    this.readMoreText = this.toggleText.textContent;
    this.readLessText = window.theme.strings.readLess || 'Read less';
    
    this.init();
  }
  
  init() {
    // Check if content needs collapsing (100px max-height + some buffer)
    if (this.description.scrollHeight <= 110) {
      this.toggle.classList.add('is-hidden');
      this.description.classList.add('is-expanded');
      return;
    }
    
    this.toggle.addEventListener('click', () => this.toggleDescription());
  }
  
  toggleDescription() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.description.classList.add('is-expanded');
      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggleText.textContent = this.readLessText;
    } else {
      this.description.classList.remove('is-expanded');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggleText.textContent = this.readMoreText;
      
      // Scroll back to description top when collapsing
      this.container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.product__description-wrapper');
  containers.forEach(container => {
    new ProductDescriptionCollapsible(container);
  });
});

// Re-initialize when product changes (for quick view, variant changes, etc.)
document.addEventListener('product:updated', () => {
  const containers = document.querySelectorAll('.product__description-wrapper');
  containers.forEach(container => {
    new ProductDescriptionCollapsible(container);
  });
});
